import { useState } from "react";
import { ProcessGroupQuerybody } from "../DataLists/ProcessGroupList/processGroupListTypes";
import { useAtom } from "jotai";
import { errorOverlayStateAtom } from "reports/components/ErrorOverlay";
import { useTenantQuery } from "reports/utils/hooks/useTenantQuery";
import { ReportParams } from "reports/types";
import { useParams } from "react-router";
import { useServiceStatus } from "components/SimpleComponents/TopBanner/useServiceStatus";
import { PROCESS_GROUPS_FOR_REPORTS_QUERY } from "components/DataGetter/ProcessGroupsGetter";

/* Runs query to grab all process groups (not only those with groupType = "FLIGHT") */
export const useFetchReportsProcessGroup = () => {
  // TODO: get RowBody instead of ProcessGroupQueryBody
  const initialState = null as ProcessGroupQuerybody[] | null;
  const [processGroup, setProcessGroup] = useState(initialState);
  const { ckey: tenant } = useParams() as ReportParams;
  const [, setErrorOverlayState] = useAtom(errorOverlayStateAtom);
  const [, setServicesStatus] = useServiceStatus();

  const { loading, error } = useTenantQuery(PROCESS_GROUPS_FOR_REPORTS_QUERY, {
    tenant,
    service: "midgard",
    onCompleted: data => {
      if (data?.processGroups && !loading && !error) {
        const processGroupsWithSortedProcesses = data.processGroups.map(pg => {
          const processesSorted = [...pg.processes].sort((a, b) => {
            const aSortOrder = pg.processesSortOrder.findIndex(
              psoId => psoId === a.id
            );
            const bSortOrder = pg.processesSortOrder.findIndex(
              psoId => psoId === b.id
            );
            return aSortOrder - bSortOrder;
          });
          return {
            ...pg,
            processes: processesSorted,
          };
        });
        setProcessGroup(processGroupsWithSortedProcesses);
      }
    },
    onError: err => {
      console.error("Error fetching process groups");
      console.log(err);
      const errString = JSON.stringify(err);
      if (
        errString.includes("Bad Gateway") ||
        errString.includes("Service Unavailable")
      ) {
        // server is definitely offline, show the banner instead
        setErrorOverlayState(prev => ({
          ...prev,
          error: false,
          message: "",
        }));
        setServicesStatus(prev => ({
          ...prev,
          midgard: {
            ...prev.midgard,
            degraded: true,
            latestError: err,
          },
        }));
      }
    },
  });
  return processGroup;
};
